/* unplugin-vue-components disabled */import script from "./AnalyzeBSView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyzeBSView.vue?vue&type=script&setup=true&lang=js"

import "./AnalyzeBSView.vue?vue&type=style&index=0&id=98b0290a&lang=css"

const __exports__ = script;

export default __exports__